export function itemBlockReason(item, sessionReady = true) {
  if (!sessionReady) return 'Open the counter before adding items';
  if (item.can_sell === false) return item.stock_issue || 'Unavailable';
  if (!Number.isFinite(Number(item.stock)) || Number(item.stock) <= 0) return 'Out of stock';
  return null;
}

export function requestedQuantity(item) {
  return item.uom === 'KG' ? Number(item.grams || 0) / 1000 : Number(item.qty || 0);
}
